/* globalmodule */
define('../src/sublayouts/m30-share/m30-share',['jquery', 'slick'], function ($) {

	'use strict';

	var M30_SHARE = function ($component) {

		this.$component = $component;

		return this;
	};

	/**
	 * Initialise component
	 */

	M30_SHARE.prototype.init = function () {
		var $this = this;
		this.$html = $('html');
		this.$isRTL = (this.$html.attr('dir') == 'rtl');
		this.shareOpen = false;

		this.$html.on('click', function () {
			$this.hideSharePanel();
		});

		$('.m30-share__item, .m30-share__link').on('click', function (e) {
			e.stopPropagation();
		});

		$('.m30-share__button').off().on('click', function (e) {
			e.stopPropagation();
			e.preventDefault();
			$this.$panel = $(this).closest('.m30-share').find('.m30-share__panel');
			var	p  = $(this).offset().top,
				ph = $this.$panel.outerHeight(),
				wh = $(window).height(),
				st = $(window).scrollTop();

			if ((((p-st) + ph) >= wh) && (p-st) >= ph) {
				$this.$panel.addClass('m30-share__panel--top');
			} else {
				$this.$panel.removeClass('m30-share__panel--top');
			}
			if ($this.$panel.attr('aria-expanded') == 'true') {
				$this.hideSharePanel();
			} else {
				$this.showSharePanel();
			}
		});
	};

	M30_SHARE.prototype.hideSharePanel = function () {
		try{
			this.$panel.removeClass('m30-share__panel--visible');
			this.$panel.attr('aria-expanded', false);
		} catch(e) {}
	};

	M30_SHARE.prototype.showSharePanel = function () {
		this.$panel.addClass('m30-share__panel--visible');
		this.$panel.attr('aria-expanded', true);
		this.$panel.fadeIn();
	};

	return M30_SHARE;
});
